import { Directive, Input, OnChanges } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  type ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[maxNumericValue]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MaxNumericValueDirective,
      multi: true,
    },
  ],
})
export class MaxNumericValueDirective implements Validator, OnChanges {
  @Input() maxNumericValue: number;

  private onValidatorChange: () => void;

  validate(control: AbstractControl): ValidationErrors | null {
    return Validators.max(this.maxNumericValue)(control);
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  ngOnChanges(): void {
    this.onValidatorChange?.();
  }
}
